<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-boxes" /> Importação de Produtos
        </h2>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Enviar planilha do Excel (.xlsx):</label>
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx"
            class="form-control-file"
            @change="onFileSelected($event)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="upload">Enviar</button>
      </div>
    </div>
    <hr />
    <button class="btn btn-success" @click="store">Importar</button>
    <div class="row">
      <div class="col-md-12 mt-5">
        <table class="table">
          <tr>
            <th v-for="column in columns">{{ column.name }}</th>

            <!-- <th>Código</th>
            <th>Gtin</th>
            <th>descrição</th>
            <th class="text-right">Valor</th>
            <th class="text-right">Valor a vista</th>
            <th class="text-right">Custo</th>
            <th>Marca</th>
            <th>Fabricante</th>
            <th>Unidade</th>
            <th>NCM</th>
            <th>CEST</th>
            <th>CSOSN</th>
            <th>origem</th>
            <th>classificação fiscal</th>
            <th>Estoque</th>
            <th>Sem Gtin</th>
            <th></th> -->
          </tr>
          <template v-for="(row, index) in products">
            <tr :key="index">
              <td v-for="column in columns">{{ row[column.key] }}</td>

              <!-- <td>{{ row.A }}</td>
              <td>{{ row.B }}</td>
              <td>{{ row.C }}</td>
              <td class="text-right">{{ row.D | decimal }}</td>
              <td class="text-right">{{ row.E | decimal }}</td>
              <td>{{ row.F }}</td>
              <td>{{ row.G }}</td>
              <td>{{ row.H }}</td>
              <td>{{ row.I }}</td>
              <td>{{ row.J }}</td>
              <td>{{ row.K }}</td>
              <td>{{ row.L }}</td>
              <td>{{ row.M }}</td>
              <td>{{ row.N }}</td>
              <td>{{ row.O }}</td>
              <td>{{ row.P }}</td> -->
              <td>
                <span v-if="isRowValid(row)">Ok</span>
                <span v-else>Erro</span>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";

export default {
  components: {},

  data: function () {
    return {
      form: {},

      columns: [
        { key: "A", name: "Código" },
        { key: "B", name: "Código de Barras" },
        { key: "C", name: "Descrição" },
        { key: "D", name: "Unidade" },
        { key: "E", name: "NCM" },
        { key: "F", name: "CEST" },
        { key: "G", name: "CSOSN" },
        { key: "H", name: "Origem" },
        { key: "I", name: "Classificação Fiscal" },
        { key: "J", name: "Preço" },
        { key: "J", name: "Preço a vista" },
        { key: "K", name: "Preço a prazo" },
        { key: "L", name: "Custo" },
        { key: "M", name: "Marca" },
        { key: "N", name: "Fabricante" },
        { key: "O", name: "Categoria" },
        { key: "P", name: "Estoque" },
        { key: "Q", name: "Estoque Mínimo" },
        { key: "R", name: "Peso Líquido" },
        { key: "S", name: "Peso Bruto" },
        { key: "T", name: "Largura" },
        { key: "U", name: "Altura" },
        { key: "V", name: "Comprimento" },
        { key: "W", name: "Observações" },
      ],

      products: [],

      //   base_sku_id: {},

      //   description: {},

      //   brand: {},

      //   value: {},

      //   gtin: {}
    };
  },

  created() {
    //this.$store.commit('pageHasLoaded')
    this.$store.commit("pageHasLoaded");
    // axios
    //   .post("../../api/billpayable/import/loaddata")
    //   .then(response => {
    //     // this.bills        = response.data.bills
    //     // this.account_plan = response.data.accountPlan;
    //     this.bills = response.data[0];
    //     console.log(response.data);
    //   })
    //   .catch(error => {
    //     this.error = error;
    //   });
  },

  methods: {
    isRowValid(row) {
      if (row.C == null) {
        return false;
      }

      return true;
    },

    onFileSelected(event) {
      console.log(event);
      this.form.file = event.target.files[0];
    },

    upload() {
      this.$store.commit("showLoading");

      let form = new FormData();
      form.append("file", this.form.file, "file");

      axios
        .post("./../api/product/import", form)
        .then((response) => {
          this.products = response.data;
          console.log(this.products["4"]);
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },

    store() {
      this.$store.commit("showLoading");

      axios
        .post("./../api/product/storeimport", this.products)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

